
/**
 * 系统配置 begin
 * dgw
 */
import _import from './_import_development'

export  default {
  path: '/sys',
  name: 'sys',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'roleList',component:_import("sys/RoleList"),name:'系统角色列表'},
    { path: 'roleAdd/:id?', component: _import("sys/RoleAdd"), name: '系统角色添加'},
    { path: 'UserList', component:  _import("sys/UserList"), name: '操作人员列表'},
    { path: 'UserAdd', component:  _import("sys/UserAdd"), name: '操作人员新增'},
    { path: 'UserInfo', component:  _import("sys/UserInfo"), name: '操作人员详情'},
    { path: 'UserBindMenu/:id?', component:  _import("sys/UserBindMenu"), name: '操作人员绑定菜单'},
    { path: 'MenuRoleList', component:  _import("sys/MenuRoleList"), name: '菜单列表'},
    { path: 'LoginLogList', component:  _import("sys/LoginLogList"), name: '登录日志'},
    { path: 'OperateLogList', component:  _import("sys/OperateLogList"), name: '操作日志'},
    { path: 'DictionaryList', component:  _import("sys/DictionaryList"), name: '数据字典'},
    { path: 'DictionaryAdd', component:  _import("sys/DictionaryAdd"), name: '新增数据字典'},
    { path: 'sysConfig', component:   _import("sys/SysConfig") , name: '配置单据号'},
    { path: 'SysNewsAdd', component:  _import("sys/SysNewsAdd"), name: '新闻公告编辑'},
    { path: 'SysNewsList', component:  _import("sys/SysNewsList"), name: '新闻公告列表'},
    { path: 'SysNewsInfo', component:  _import("sys/SysNewsInfo"), name: '新闻公告列表'},
    { path: 'SysNewsInfoPreview', component:  _import("sys/SysNewsInfoPreview"), name: '新闻公告预览'},
    { path: 'SysUpdateLogList', component:  _import("sys/SysUpdateLogList"), name: '同步日志列表'},
    { path: 'WbCompanyList', component:  _import("sys/WbCompanyList"), name: '公司对照列表'},
    { path: 'WbCompanyEdit', component:  _import("sys/WbCompanyEdit"), name: '公司对照编辑'},
    { path: 'WbProductList', component:  _import("sys/WbProductList"), name: '商品对照列表'},
    { path: 'WbProductEdit', component:  _import("sys/WbProductEdit"), name: '商品对照编辑'},
    { path: 'WbCustomerList', component:  _import("sys/WbCustomerList"), name: '客户对照列表'},
    { path: 'WbCustomerEdit', component:  _import("sys/WbCustomerEdit"), name: '客户对照编辑'},
    { path: 'WbOrderList', component:  _import("sys/WbOrderList"), name: '外部订单列表'},
    { path: 'WbOrderInfo', component: _import("sys/WbOrderInfo"), name: '外部订单详情' },
    { path: 'wbOrderVO', component: _import("sys/wbOrderVO"), name: '订单信息对照' },

    { path: 'WbSystemList', component:  _import("sys/WbSystemList"), name: '外部系统列表'},
    { path: 'WbSystemEdit', component:  _import("sys/WbSystemEdit"), name: '外部系统编辑'},

    { path: 'tongbu', component: _import("sys/tongbu"), name: '订单信息对照' },

    { path: 'MNOrderList', component:  _import("sys/MNOrderList"), name: '美年订单列表'},
    { path: 'MNOrderInfo', component: _import("sys/MNOrderInfo"), name: '美年订单详情' },


    { path: 'YYGOrderList', component:  _import("sys/YYGOrderList"), name: '云医购订单列表'},
    { path: 'YYGOrderInfo', component:  _import("sys/YYGOrderInfo"), name: '云医购订单列表'},

    { path: 'SysDeliveryAdd', component:  _import("sys/SysDeliveryAdd"), name: '交期设置新增'},
    { path: 'SysDeliveryInfo', component:  _import("sys/SysDeliveryInfo"), name: '交期设置详情'},
    { path: 'SysDeliveryList', component:  _import("sys/SysDeliveryList"), name: '交期设置列表'},
    { path: 'SysDeliveryUpdate', component:  _import("sys/SysDeliveryUpdate"), name: '交期设置修改'},
  ]
}



// WEBPACK FOOTER //
// ./src/router/sys.js